/**
 * Interface representing the options for exporting data as CSV in AG Grid.
 *
 * @template ParamType - The type of the parameter object passed to the callback.
 * @template ReturnType - The type of the value returned by the callback.
 */
export interface IAgGridExportSettings {
  /** A flag to indicate whether to export all columns, including those not visible. */
  allColumns?: boolean;

  /** An array of column keys to specify which columns to include in the export. */
  columnKeys?: string[];

  /** A custom separator to use in the CSV file. Defaults to a comma (','). */
  columnSeparator?: string;

  /** The name of the exported CSV file. */
  fileName?: string;

  /** A flag to indicate whether to export only the selected rows. */
  onlySelected?: boolean;

  /** A callback function to process each cell's data before exporting. */
  processCellCallback?<ParamType, ReturnType>(params: ParamType): ReturnType;

  /** A flag to indicate whether to suppress quotes in the CSV output. */
  suppressQuotes?: boolean;
}

export const DEFAULT_AG_GRID_SETTINGS: IAgGridExportSettings = {
  fileName: 'NO_FILENAME_GIVEN',
  columnKeys: [],
  allColumns: false,
  onlySelected: false,
  suppressQuotes: true,
  columnSeparator: ',',
};
